<template>
  <page>
    <template slot="content">
    <help-content :title="'ホームを下スワイプしても同期しない'">
      <template slot="content">
        <div class="text">
          ・タスク画面（Androidの■ボタンをタップ、iPhoneのHomeボタンをダブルクリック）からアプリを消してから、
          再度アプリを開いてご確認ください。<br><br>
          ・iPhoneの場合、設定画面の一般＞言語と地域＞暦法を必ず<b>西暦</b>に設定してください。
        </div>
        <img class="picture" src="../assets/images/q_and_a/H25.png">
      </template>
    </help-content>
    </template>
  </page>
</template>

<script>
  import HelpContent from '@/components/HelpContent'
  import Page from '@/components/Page'

  export default {
    components: {
      HelpContent,
      Page
    },
    mounted () {
      window.scrollTo(0, 0)
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Help25.vue